import React from 'react';

const PythonLogo = (props) => (
    <svg viewBox="0 0 518.5 153.4" {...props}>
        <defs>
            <linearGradient id="python-prefix__c">
                <stop offset={0} stopColor="#b8b8b8" stopOpacity={0.5} />
                <stop offset={1} stopColor="#7f7f7f" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="python-prefix__a">
                <stop offset={0} stopColor="#ffd43b" />
                <stop offset={1} stopColor="#ffe873" />
            </linearGradient>
            <linearGradient id="python-prefix__b">
                <stop offset={0} stopColor="#5a9fd4" />
                <stop offset={1} stopColor="#306998" />
            </linearGradient>
            <linearGradient
                id="python-e"
                x1={151}
                x2={112}
                y1={192.4}
                y2={137.3}
                gradientTransform="matrix(.56254 0 0 .56797 -9.4 -5.3)"
                gradientUnits="userSpaceOnUse"
                xlinkHref="#python-prefix__a"
            />
            <linearGradient
                id="python-d"
                x1={26.6}
                x2={135.7}
                y1={20.6}
                y2={114.4}
                gradientTransform="matrix(.56254 0 0 .56797 -9.4 -5.3)"
                gradientUnits="userSpaceOnUse"
                xlinkHref="#python-prefix__b"
            />
            <radialGradient
                id="python-f"
                cx={61.5}
                cy={132.3}
                r={29}
                fx={61.5}
                fy={132.3}
                gradientTransform="matrix(0 -.2964 1.43676 0 -128.5 150.5)"
                gradientUnits="userSpaceOnUse"
                xlinkHref="#python-prefix__c"
            />
        </defs>
        <path
            fill="#646464"
            d="M184.6 62c0-14.6-4.1-22.1-12.4-22.5-3.3-.2-6.6.4-9.7 1.6-2.5.9-4.2 1.8-5 2.7v34.7c5.2 3.3 10 4.9 14 4.6 8.8-.5 13.1-7.6 13.1-21.2zm10.3.5c0 7.4-1.8 13.6-5.3 18.5a19.3 19.3 0 01-16.1 8.5c-5.2.2-10.6-1.5-16-4.9v31.6l-9-3.2V43c1.5-1.8 3.3-3.3 5.6-4.6 5.3-3.1 11.8-4.7 19.4-4.8v.1c7 0 12.4 2.8 16.1 8.6 3.5 5.3 5.3 12 5.3 20.3zm54.4 20.8c0 9.9-1 16.8-3 20.6A21 21 0 01235 113a43.7 43.7 0 01-14.7 3l-1.5-5.7a71 71 0 0011.3-2.1 15 15 0 009-6.8c1.2-2.4 1.9-7 1.9-14v-2.3c-6.1 2.8-12.5 4.1-19.2 4.1-4.4 0-8.2-1.3-11.6-4.1a14 14 0 01-5.6-11.5v-37l9-3v37.2c0 4 1.2 7 3.8 9.2 2.6 2.2 5.9 3.2 10 3.1 4 0 8.4-1.6 13.1-4.7V34.9h8.9v48.4zM284 89l-2.9.1c-5 0-9-1.2-11.7-3.6a12.5 12.5 0 01-4.2-10v-35H259v-5.6h6v-15l9-3.1v18h10v5.7h-10v34.8c0 3.3.9 5.7 2.7 7.1 1.5 1.1 4 1.8 7.3 2V89zm54-.7h-8.9V53.9c0-3.5-.8-6.5-2.4-9a8.9 8.9 0 00-7.9-4.3c-4 0-9.2 2.1-15.3 6.4v41.3h-9V6l9-2.8v37.4a31 31 0 0118.7-6.2c4.7 0 8.5 1.6 11.4 4.7 3 3.2 4.4 7.2 4.4 11.9v37.2zm47.4-27.8c0-5.6-1-10.2-3.2-13.8a13.3 13.3 0 00-11.7-7c-9.8.5-14.6 7.5-14.6 20.9 0 6.1 1 11.3 3 15.4 2.6 5.2 6.5 7.8 11.8 7.8 9.8-.1 14.7-7.9 14.7-23.3zm9.7 0c0 8-2 14.7-6 20a22 22 0 01-18.6 8.9c-7.8 0-14-3-18.3-9-4-5.2-6-11.9-6-19.8 0-7.5 2.2-13.8 6.5-19a22.3 22.3 0 0118-8c7.3 0 13.3 2.6 18 8a28.4 28.4 0 016.4 19zm51.1 27.8h-8.9V51.9c0-4-1.2-7-3.6-9.3a13 13 0 00-9.6-3.2c-4.2 0-8.2 1.4-12 4.1v44.8h-9V42.4c5.2-3.7 9.9-6.2 14.2-7.3 4-1 7.6-1.6 10.7-1.6 2.1 0 4.1.2 6 .6 3.5.8 6.3 2.3 8.5 4.5a12 12 0 013.7 8.8v40.9z"
        />
        <path
            fill="url(#python-d)"
            d="M60.5 6.4c-4.6 0-9 .4-12.8 1-11.3 2.1-13.4 6.3-13.4 14v10.2H61v3.5H24.3c-7.9 0-14.7 4.6-16.8 13.5a50.1 50.1 0 000 27.3c1.9 8 6.4 13.6 14.2 13.6H31V77.2a17 17 0 0116.8-16.6h26.8C82 60.6 88 54.4 88 47V21.4c0-7.2-6.1-12.7-13.4-14-4.6-.7-9.4-1-14-1zM46 14.6a5 5 0 015 5.1 5 5 0 01-5 5.1 5 5 0 01-5-5 5 5 0 015-5.2z"
        />
        <path
            fill="url(#python-e)"
            d="M91.2 35v12c0 9.2-7.8 17-16.7 17H47.7c-7.3 0-13.4 6.2-13.4 13.6V103c0 7.3 6.3 11.6 13.4 13.6 8.5 2.5 16.6 3 26.8 0 6.7-2 13.4-5.8 13.4-13.6V93H61v-3.4h40.2c7.8 0 10.7-5.4 13.4-13.6a46 46 0 000-27.3c-2-7.7-5.6-13.5-13.4-13.5h-10zm-15 64.7a5 5 0 015 5.1 5 5 0 01-5 5.1 5 5 0 01-5-5.1 5 5 0 015-5z"
        />
        <path
            fill="url(#python-f)"
            d="M110.5 132.3a49 8.6 0 11-98 0 49 8.6 0 1198 0z"
            opacity={0.4}
            transform="matrix(.73406 0 0 .80952 16.2 27)"
        />
    </svg>
);

export default PythonLogo;
